var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-type-wrap"},_vm._l((_vm.navList),function(item,index){return _c('router-link',{key:index,class:[{ 'active': _vm.path == item.url }, 'item'],attrs:{"to":{ path: item.url }}},[_vm._v(_vm._s(item.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }